import { Box, Container } from '@mui/material';
import { withStyles } from '@mui/styles'
import { FC, useState } from 'react';
import { User, Workday } from './models/workday';
import { Header } from './components/Header';
import { DutyActivity } from './components/DutyActivity';
import { AdminCard } from './components/AdminCard/AdminCard';
import TransdevThemeProvider from './TransdevThemeProvider';

type Props = {
  user: User;
};

const StyledContainer = withStyles((props) => {
  return ({
    root: {
      padding: '0'
    }
  })
})(Container)

const App: FC<Props> = ({ user }) => {
  const wdStart = user.Workdays.find(
    (x) =>
      x.WdyDate.toString().split('T')[0] === new Date(Date.now()).toISOString().split('T')[0]
  )!;
  const [currentWorkdayDate, setCurrentWorkdayDate] = useState<string>(
    wdStart?.WdyDate.toString().split('T')[0]
  );

  const handleDateChange = (date: Date) => {
    setCurrentWorkdayDate(date.toISOString().split('T')[0])
  };
  const currentWorkday = user.Workdays?.find(
    (wdy) => wdy.WdyDate.toString().split('T')[0] === currentWorkdayDate
  ) as unknown as Workday
  
  return (
    <>
      <TransdevThemeProvider>
        <StyledContainer fixed maxWidth="xs">
          {user.IsAdmin && (
            <Box py={1}>
              <AdminCard />
            </Box>
          )}
          {!user.IsAdmin && (
            <>
              <Header
                workdays={user.Workdays}
                currentWorkday={currentWorkday}
                handleDateChange={handleDateChange}
              />
              {(currentWorkday?.ScheduledToWork === undefined ||
                currentWorkday?.ScheduledToWork) && (
                <Box>
                  {currentWorkday !== undefined &&
                    currentWorkday?.DutyActivity?.map((da) => (
                      <DutyActivity currentWorkday={currentWorkday} dutyActivity={da} user={user} />
                    ))}
                </Box>
              )}
            </>
          )}
        </StyledContainer>
      </TransdevThemeProvider>
    </>
  );
};

export default App;
